export const NOTICE_TYPE_IMAGE = 0
export const NOTICE_TYPE_VIDEO = 1
export const UPLOAD_FILE_TYPE_IMAGE = 1
export const UPLOAD_FILE_TYPE_VIDEO = 2

const qiniuImageURLPrefix = 'https://img.senguo.cc/'
const qiniuVideoURLPrefix = 'https://v.senguo.cc/'

export interface SecondaryScreenNotice {
    id: number
    notice_type: number | string
    notice_source?: number
    qiniu_key: string
}

export interface SecondaryScreenNoticeResponse {
    image_notices?: SecondaryScreenNotice[]
    video_notices?: SecondaryScreenNotice[]
}

export interface SecondaryScreenNoticeUploadResult {
    key: string
    imgSrc: string
    uid?: string
    name?: string
    size?: number
    duration?: number | null
    proportion?: string | null
}

export interface SecondaryScreenNoticeUploadParam {
    notice_type: number
    qiniu_key: string
    material_info: {
        uid: string
        material_type: number
        name: string
        url: string
        size: number
        duration?: number | null
        proportion?: string | null
    }
}

export function getSecondaryScreenNoticeList(res: SecondaryScreenNoticeResponse) {
    return ([] as SecondaryScreenNotice[]).concat(res.image_notices || [], res.video_notices || [])
}

export function isSecondaryScreenVideoNotice(notice: Pick<SecondaryScreenNotice, 'notice_type' | 'qiniu_key'>) {
    return +notice.notice_type === NOTICE_TYPE_VIDEO || /\.(mp4|mov|m4v)(\?|$)/i.test(notice.qiniu_key)
}

export function getSecondaryScreenNoticePreviewUrl(notice: Pick<SecondaryScreenNotice, 'notice_type' | 'qiniu_key'>, width = 800) {
    if (isSecondaryScreenVideoNotice(notice)) {
        return `${qiniuVideoURLPrefix}${notice.qiniu_key}?vframe/jpg/offset/0/w/${width}`
    }

    return `${qiniuImageURLPrefix}${notice.qiniu_key}?imageView2/1/w/${width}`
}

export function getSecondaryScreenNoticeVideoUrl(notice: Pick<SecondaryScreenNotice, 'qiniu_key'>) {
    return `${qiniuVideoURLPrefix}${notice.qiniu_key}`
}

export function buildSecondaryScreenNoticeUploadParam(
    noticeType: typeof NOTICE_TYPE_IMAGE | typeof NOTICE_TYPE_VIDEO,
    uploadResult: SecondaryScreenNoticeUploadResult
): SecondaryScreenNoticeUploadParam {
    const materialType = noticeType === NOTICE_TYPE_VIDEO ? UPLOAD_FILE_TYPE_VIDEO : UPLOAD_FILE_TYPE_IMAGE

    return {
        notice_type: noticeType,
        qiniu_key: uploadResult.key,
        material_info: {
            uid: uploadResult.uid || `${Date.now()}-${uploadResult.key}`,
            material_type: materialType,
            name: uploadResult.name || uploadResult.key,
            url: uploadResult.key,
            size: uploadResult.size || 0,
            duration: noticeType === NOTICE_TYPE_VIDEO ? uploadResult.duration || null : null,
            proportion: noticeType === NOTICE_TYPE_IMAGE ? uploadResult.proportion || null : null
        }
    }
}
